import { useCallback, useEffect, useState } from 'react';
import { listCommercialOperations } from '@/modules/commercial/services';
import type { CommercialOperation } from '@/modules/commercial/types';

export function useCommercialOperations() {
  const [operations, setOperations] = useState<CommercialOperation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setOperations(await listCommercialOperations());
    } catch {
      setError('No se pudieron cargar las operaciones.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { operations, loading, error, refresh };
}
